import styled from "styled-components";
import { IconButton, Logo, Title } from "../../components";
import { State } from "../../types";
import { defaultThemeStyles } from "../../mocks";
import { SanitisedHtmlContent } from "../../components/SanitisedHtmlContent/SanitisedHtmlContent";
import { useTranslation } from "react-i18next";
import { ArrowLeftSolid } from "../../assets/icons";

const StyledPageContainer = styled.div`
  display: grid;
  row-gap: 16px;
`;

const StyledHeader = styled.div`
  display: grid;
  grid-template-columns: 30px 1fr 30px;
  justify-content: center;
  align-items: center;
`;

const StyledTitle = styled(Title)`
  text-align: center;
  flex-grow: 1;
`;

const StyledSection = styled.div`
  display: grid;
  row-gap: 8px;
  max-height: 380px;
`;

const StyledContainer = styled.div`
  overflow-y: scroll;
  padding: 15px;
`;

export type TermsAndConditionsPageProps = {
  state: State;
  prevPage: (payload: Partial<State>) => void;
};

export const TermsAndConditionsPage: React.FC<TermsAndConditionsPageProps> = ({
  state,
  prevPage,
}) => {
  const { t } = useTranslation();

  const backButtonClick = () => {
    prevPage(state);
  };

  return (
    <StyledPageContainer>
      <Logo styles={state.crossSellSetup?.ThemeStyles || defaultThemeStyles} />
      <StyledHeader>
        <IconButton
          styles={state.crossSellSetup?.ThemeStyles || defaultThemeStyles}
          icon={ArrowLeftSolid}
          ariaLabel={t("Previous")}
          onClick={backButtonClick}
          dataId="back-button"
        />
        <StyledTitle
          styles={state.crossSellSetup?.ThemeStyles || defaultThemeStyles}
        >
          {t("TermsAndConditions")}
        </StyledTitle>
      </StyledHeader>
      <StyledSection>
        <StyledContainer tabIndex={0}>
          <SanitisedHtmlContent
            content={
              state.activeTermsAndPrivacyPolicy?.TermsAndConditions || ""
            }
            styles={state.crossSellSetup?.ThemeStyles || defaultThemeStyles}
          />
        </StyledContainer>
      </StyledSection>
    </StyledPageContainer>
  );
};

export default TermsAndConditionsPage;
